import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  public getHostname(): string {
    return window.location.hostname;
  }

  public getWindow(): Window {
    return window;
  }

  public setHref(href: string): any {
    return (window.location.href = href);
  }
}
